import AxiosConfig from '../../../config/AxiosConfig';

const useStoresFilter = () => {
  const getStoresByFilter = async (filter) => {
    const res = AxiosConfig.create('put', '/stores/')
      .call(filter)
      .getResponseData();
    return res;
  };
  return { getStoresByFilter };
};

export default useStoresFilter;
